import { IUsageLoggingService } from "src/services/IUsageLoggingService";
import {INavScope, NavCtrl} from "../nav";

export interface IOENavScope extends INavScope, ng.IScope {
	metaLayerSelectorActive: boolean;
}

export class OENavCtrl extends NavCtrl {
	constructor(
		$scope: IOENavScope,
		usageLoggingService: IUsageLoggingService,
	) {
		super($scope, usageLoggingService);
		$scope.metaLayerSelectorActive = true;

		$scope.$on('paneLayerSelector:change', (ev, onOrOff) => {
			$scope.metaLayerSelectorActive = onOrOff;
		});

		$scope.xsNavUlClass = () => {
			return {
				'meta-layer-selector-active' : $scope.metaLayerSelectorActive,
				'xs-nav-active' : !$scope.isNavCollapsed
			};
		};
	}
}
